module.exports = __webpack_public_path__ + "static/media/gem.fd2c4117.svg";